module.exports = __webpack_public_path__ + "img/origin-1.007626f3.png";